import React from 'react';

import FormikInput from "components/input/new/FormikInput";

function MarketplaceCodeField(props) {
    return (
        <FormikInput
            name={'shippingMethodShopName'}
            label={'shippingMethods.form.field.shippingMethodShopName.label'}
            placeholder={'shippingMethods.form.field.shippingMethodShopName.placeholder'}
            required={true}
        />
    );
}

export default MarketplaceCodeField;
